import * as React from 'react';
import { IconSizes } from '@newcore/icons';
import { Spinner } from '@newcore/ui/loading';
import {
  ONBOARDING_DEFAULT_TITLE,
  OnboardingStatusCard,
} from './onboarding-status-card';

interface OnboardingPageLoadingProps {
  title?: string;
  message?: string;
}

export function OnboardingPageLoading({
  title = ONBOARDING_DEFAULT_TITLE,
  message = 'Validating your invitation...',
}: OnboardingPageLoadingProps): React.ReactElement {
  return (
    <OnboardingStatusCard title={title} description={message}>
      <Spinner size={IconSizes.LG} className='text-primary' />
    </OnboardingStatusCard>
  );
}
